

















import { defineComponent, computed, watch, ref, reactive } from "@vue/composition-api";
import { D, E } from '../../helpers/dom';

const componentName = 'dropdown-menu';

export default defineComponent({
    props: {},
    name: componentName,

    setup(props, context) {
        const state = reactive({
            showPopup: false
        });

        const onClick = () => {
            state.showPopup = !state.showPopup;
            E(document).once('click', (evt: Event) => {
                if (evt.target instanceof HTMLElement && !D(evt.target).inside(<HTMLElement>context.root.$el)) {
                    state.showPopup = false;
                    return true;
                }
                return false;
            });
        }

        return {
            state,
            onClick
        }
    }
})

